export const stateUniversityGuide = [
  {
    state: 'Andhra Pradesh',
    topUniversities: ['Andhra University, Visakhapatnam', 'K L University, Vaddeswaram'],
    centralUniversities: ['Central University of Andhra Pradesh', 'Central Tribal University of Andhra Pradesh', 'National Sanskrit University'],
    bestFor: 'Engineering, sciences, humanities, Sanskrit, tribal studies',
    admissionNote: 'UG admission is usually through CUET, AP EAPCET, university merit lists, or course-specific counselling.',
  },
  {
    state: 'Arunachal Pradesh',
    topUniversities: ['Rajiv Gandhi University, Itanagar'],
    centralUniversities: ['Rajiv Gandhi University'],
    bestFor: 'Humanities, social sciences, education, basic sciences',
    admissionNote: 'Central university UG/PG seats generally use CUET or university notification-based counselling.',
  },
  {
    state: 'Assam',
    topUniversities: ['Gauhati University', 'Tezpur University', 'Assam University'],
    centralUniversities: ['Tezpur University', 'Assam University'],
    bestFor: 'Engineering, humanities, sciences, northeast studies',
    admissionNote: 'Check CUET rules for central universities and separate state university portals for local colleges.',
  },
  {
    state: 'Bihar',
    topUniversities: ['Patna University', 'Central University of South Bihar', 'Nalanda University'],
    centralUniversities: ['Central University of South Bihar', 'Mahatma Gandhi Central University', 'Nalanda University', 'Dr. Rajendra Prasad Central Agricultural University'],
    bestFor: 'Humanities, agriculture, Buddhist studies, public policy, teacher education',
    admissionNote: 'Central universities use CUET or their own PG process; state universities publish separate merit/counselling notices.',
  },
  {
    state: 'Chhattisgarh',
    topUniversities: ['Guru Ghasidas Vishwavidyalaya', 'Pt. Ravishankar Shukla University'],
    centralUniversities: ['Guru Ghasidas Vishwavidyalaya'],
    bestFor: 'Science, commerce, humanities, law, pharmacy',
    admissionNote: 'Central seats are usually CUET-based; state university affiliated colleges use local admission portals.',
  },
  {
    state: 'Goa',
    topUniversities: ['Goa University'],
    centralUniversities: ['No dedicated central university in the state'],
    bestFor: 'Marine science, humanities, commerce, management',
    admissionNote: 'Most admissions run through Goa University or professional entrance/counselling bodies.',
  },
  {
    state: 'Gujarat',
    topUniversities: ['Gujarat University', 'Maharaja Sayajirao University of Baroda', 'Central University of Gujarat'],
    centralUniversities: ['Central University of Gujarat'],
    bestFor: 'Commerce, science, social sciences, language studies',
    admissionNote: 'Use CUET for central university seats and ACPC or university portals for many professional/state seats.',
  },
  {
    state: 'Haryana',
    topUniversities: ['Maharshi Dayanand University', 'Kurukshetra University', 'Central University of Haryana'],
    centralUniversities: ['Central University of Haryana'],
    bestFor: 'Engineering, humanities, law, education, management',
    admissionNote: 'Admissions can be CUET-based, merit-based, or handled by Haryana counselling authorities by course.',
  },
  {
    state: 'Himachal Pradesh',
    topUniversities: ['Himachal Pradesh University', 'Central University of Himachal Pradesh'],
    centralUniversities: ['Central University of Himachal Pradesh'],
    bestFor: 'Humanities, sciences, education, tourism, environmental studies',
    admissionNote: 'Central university seats follow CUET/department rules; state seats follow HPU or college notifications.',
  },
  {
    state: 'Jharkhand',
    topUniversities: ['Ranchi University', 'Central University of Jharkhand'],
    centralUniversities: ['Central University of Jharkhand'],
    bestFor: 'Tribal studies, humanities, science, engineering-linked programs',
    admissionNote: 'Track CUET for central programs and state university portals for affiliated college admissions.',
  },
  {
    state: 'Karnataka',
    topUniversities: ['Indian Institute of Science, Bengaluru', 'Manipal Academy of Higher Education', 'University of Mysore'],
    centralUniversities: ['Central University of Karnataka'],
    bestFor: 'Research, science, engineering, medical allied fields, liberal arts',
    admissionNote: 'Professional seats often use KCET/COMEDK/NEET; central university seats may use CUET.',
  },
  {
    state: 'Kerala',
    topUniversities: ['University of Kerala', 'Cochin University of Science and Technology', 'Mahatma Gandhi University'],
    centralUniversities: ['Central University of Kerala'],
    bestFor: 'Science, humanities, marine studies, social sciences, health sciences',
    admissionNote: 'Kerala CEE handles many professional courses; universities release separate UG/PG admission lists.',
  },
  {
    state: 'Madhya Pradesh',
    topUniversities: ['Devi Ahilya Vishwavidyalaya', 'Dr. Harisingh Gour Vishwavidyalaya'],
    centralUniversities: ['Dr. Harisingh Gour Vishwavidyalaya'],
    bestFor: 'Science, commerce, humanities, law, management',
    admissionNote: 'Central university admissions are commonly CUET-linked; state universities use merit and state counselling.',
  },
  {
    state: 'Maharashtra',
    topUniversities: ['University of Mumbai', 'Savitribai Phule Pune University', 'Institute of Chemical Technology'],
    centralUniversities: ['Mahatma Gandhi Antarrashtriya Hindi Vishwavidyalaya'],
    bestFor: 'Commerce, engineering, chemical technology, humanities, media',
    admissionNote: 'MHT CET/CAP covers many professional seats; universities and colleges publish program-wise merit lists.',
  },
  {
    state: 'Manipur',
    topUniversities: ['Manipur University'],
    centralUniversities: ['Manipur University'],
    bestFor: 'Humanities, social sciences, life sciences, regional studies',
    admissionNote: 'Check CUET/university notices for central university intake and department-wise eligibility.',
  },
  {
    state: 'Meghalaya',
    topUniversities: ['North-Eastern Hill University'],
    centralUniversities: ['North-Eastern Hill University'],
    bestFor: 'Humanities, science, social sciences, northeast studies',
    admissionNote: 'Central university admission is usually through CUET or NEHU program notifications.',
  },
  {
    state: 'Mizoram',
    topUniversities: ['Mizoram University'],
    centralUniversities: ['Mizoram University'],
    bestFor: 'Education, humanities, social sciences, environmental studies',
    admissionNote: 'CUET and university merit routes vary by course; check the latest admission brochure.',
  },
  {
    state: 'Nagaland',
    topUniversities: ['Nagaland University'],
    centralUniversities: ['Nagaland University'],
    bestFor: 'Humanities, science, agriculture-linked programs, education',
    admissionNote: 'Most programs require online registration followed by merit/counselling as notified by the university.',
  },
  {
    state: 'Odisha',
    topUniversities: ['Siksha O Anusandhan', 'Kalinga Institute of Industrial Technology', 'Utkal University'],
    centralUniversities: ['Central University of Odisha'],
    bestFor: 'Engineering, medical allied courses, humanities, management',
    admissionNote: 'OJEE/NEET/JEE routes apply for professional courses; central university courses may use CUET.',
  },
  {
    state: 'Punjab',
    topUniversities: ['Panjab University', 'Thapar Institute of Engineering and Technology', 'Central University of Punjab'],
    centralUniversities: ['Central University of Punjab'],
    bestFor: 'Engineering, sciences, humanities, law, pharmacy',
    admissionNote: 'Central university seats can be CUET-based; technical seats often use JEE or institute counselling.',
  },
  {
    state: 'Rajasthan',
    topUniversities: ['BITS Pilani', 'University of Rajasthan', 'Central University of Rajasthan'],
    centralUniversities: ['Central University of Rajasthan'],
    bestFor: 'Engineering, science, humanities, management, teacher education',
    admissionNote: 'BITSAT/JEE/NEET apply by program; central university admissions commonly follow CUET.',
  },
  {
    state: 'Sikkim',
    topUniversities: ['Sikkim University'],
    centralUniversities: ['Sikkim University'],
    bestFor: 'Humanities, science, ecology, Himalayan studies',
    admissionNote: 'Central university programs usually require CUET scores or university-defined merit rules.',
  },
  {
    state: 'Tamil Nadu',
    topUniversities: ['Anna University', 'University of Madras', 'Amrita Vishwa Vidyapeetham'],
    centralUniversities: ['Central University of Tamil Nadu'],
    bestFor: 'Engineering, science, humanities, research, health sciences',
    admissionNote: 'TNEA handles many engineering seats; CUET may apply for central university programs.',
  },
  {
    state: 'Telangana',
    topUniversities: ['University of Hyderabad', 'Osmania University', 'English and Foreign Languages University'],
    centralUniversities: ['University of Hyderabad', 'English and Foreign Languages University', 'Maulana Azad National Urdu University'],
    bestFor: 'Research, sciences, languages, humanities, social sciences',
    admissionNote: 'Central universities use CUET or university rules; Telangana professional seats use state counselling.',
  },
  {
    state: 'Tripura',
    topUniversities: ['Tripura University'],
    centralUniversities: ['Tripura University'],
    bestFor: 'Science, humanities, education, regional studies',
    admissionNote: 'Admissions are generally online with CUET/merit rules depending on program level.',
  },
  {
    state: 'Uttar Pradesh',
    topUniversities: ['Banaras Hindu University', 'Aligarh Muslim University', 'University of Allahabad'],
    centralUniversities: ['Banaras Hindu University', 'Aligarh Muslim University', 'University of Allahabad', 'Babasaheb Bhimrao Ambedkar University', 'Rajiv Gandhi National Aviation University', 'Rani Lakshmi Bai Central Agricultural University'],
    bestFor: 'Science, humanities, medicine, law, agriculture, aviation',
    admissionNote: 'BHU/AMU/Allahabad often use CUET for many UG courses; professional courses follow NEET/JEE/CLAT where applicable.',
  },
  {
    state: 'Uttarakhand',
    topUniversities: ['Hemvati Nandan Bahuguna Garhwal University', 'Graphic Era University', 'UPES'],
    centralUniversities: ['Hemvati Nandan Bahuguna Garhwal University'],
    bestFor: 'Science, humanities, petroleum/energy, management, environmental studies',
    admissionNote: 'Central university seats can use CUET; private/deemed universities run their own applications.',
  },
  {
    state: 'West Bengal',
    topUniversities: ['Jadavpur University', 'University of Calcutta', 'Visva-Bharati'],
    centralUniversities: ['Visva-Bharati'],
    bestFor: 'Engineering, humanities, fine arts, science, research',
    admissionNote: 'State universities publish merit/entrance rules; central university programs may require CUET or university-specific selection.',
  },
];

export const unionTerritoryUniversityGuide = [
  {
    state: 'Delhi',
    topUniversities: ['Jawaharlal Nehru University', 'Jamia Millia Islamia', 'University of Delhi'],
    centralUniversities: ['University of Delhi', 'Jawaharlal Nehru University', 'Jamia Millia Islamia', 'Indira Gandhi National Open University', 'Central Sanskrit University', 'Shri Lal Bahadur Shastri National Sanskrit University'],
    bestFor: 'Humanities, commerce, science, languages, distance education, research',
    admissionNote: 'DU, JNU and JMI publish their own counselling portals after CUET or program-specific entrance requirements.',
  },
  {
    state: 'Jammu and Kashmir',
    topUniversities: ['University of Kashmir', 'University of Jammu', 'Central University of Kashmir'],
    centralUniversities: ['Central University of Kashmir', 'Central University of Jammu'],
    bestFor: 'Humanities, science, management, education, regional studies',
    admissionNote: 'Central universities usually use CUET/online counselling; state universities release their own merit lists.',
  },
  {
    state: 'Ladakh',
    topUniversities: ['University of Ladakh'],
    centralUniversities: ['No dedicated central university in the UT'],
    bestFor: 'Mountain studies, humanities, commerce, science foundations',
    admissionNote: 'Students should track University of Ladakh notices and national entrances for professional courses.',
  },
  {
    state: 'Chandigarh',
    topUniversities: ['Panjab University'],
    centralUniversities: ['No dedicated central university headquartered in the UT'],
    bestFor: 'Law, humanities, science, pharmacy, management',
    admissionNote: 'Panjab University and affiliated colleges publish course-wise entrance/merit schedules.',
  },
  {
    state: 'Puducherry',
    topUniversities: ['Pondicherry University'],
    centralUniversities: ['Pondicherry University'],
    bestFor: 'Humanities, management, science, international studies',
    admissionNote: 'Pondicherry University commonly uses CUET or university rules depending on program level.',
  },
  {
    state: 'Andaman and Nicobar Islands',
    topUniversities: ['Pondicherry University affiliated campus/colleges'],
    centralUniversities: ['No dedicated central university in the UT'],
    bestFor: 'General UG degrees, marine/location-linked studies',
    admissionNote: 'Local colleges are commonly affiliated to Pondicherry University; check college notices and national entrances.',
  },
  {
    state: 'Dadra and Nagar Haveli and Daman and Diu',
    topUniversities: ['Nearby Gujarat/Maharashtra universities and local affiliated colleges'],
    centralUniversities: ['No dedicated central university in the UT'],
    bestFor: 'General degrees through affiliated colleges; professional courses via state/national counselling',
    admissionNote: 'Students often use nearby state university systems, CUET, NEET, JEE, or professional counselling routes.',
  },
  {
    state: 'Lakshadweep',
    topUniversities: ['Mainland universities and distance/open university routes'],
    centralUniversities: ['No dedicated central university in the UT'],
    bestFor: 'Distance education, mainland college admissions, professional entrance routes',
    admissionNote: 'Students generally apply through mainland universities, IGNOU, CUET, NEET, JEE, or state counselling.',
  },
];

export const admissionProcessGuide = [
  {
    title: '1. Decide the course first',
    details: 'Shortlist the exact program: BA, B.Sc, B.Com, B.Tech, MBBS, BBA, BCA, law, design, agriculture, pharmacy, or diploma. Admission rules change by course, not only by university.',
  },
  {
    title: '2. Check the required entrance route',
    details: 'Central universities commonly use CUET for many UG programs. Engineering may need JEE Main/state CET. Medical needs NEET. Law may need CLAT/AILET/state law tests. Design may need NID/NIFT/UCEED or institute tests.',
  },
  {
    title: '3. Register for the entrance exam',
    details: 'Create the application, upload photo/signature/category certificates if applicable, choose subjects carefully, pay the fee, and download the confirmation page.',
  },
  {
    title: '4. Apply on the university admission portal',
    details: 'After entrance results, many universities require a separate form on their own portal. Fill course preferences, college preferences, category, marks, and entrance score details.',
  },
  {
    title: '5. Track merit list, seat allocation, and counselling rounds',
    details: 'Universities release merit lists or seat allotment rounds. If allotted, accept/freeze/upgrade as per portal instructions and complete document verification before the deadline.',
  },
  {
    title: '6. Keep documents ready',
    details: 'Class 10 marksheet, Class 12 marksheet, transfer/migration certificate, category/EWS/PwD certificate if applicable, entrance scorecard, ID proof, photos, and payment receipt are commonly needed.',
  },
  {
    title: '7. Pay admission fee and confirm seat',
    details: 'A seat is not final until the university accepts documents and fee payment. Save receipts and check whether physical reporting is required.',
  },
  {
    title: '8. Watch for spot rounds and upgrades',
    details: 'If you miss the first list, do not panic. Many universities run additional rounds, upgrade windows, vacant-seat rounds, and spot admissions.',
  },
];

export const centralUniversityHighlights = [
  'Central universities are established by Parliament and are funded/regulated at the national level.',
  'Many UG admissions now depend on CUET scores, but each university still controls eligibility, subject mapping, reservations, and counselling.',
  'For professional courses, national entrance rules override general university admission: NEET for MBBS/BDS, JEE for many engineering seats, CLAT/AILET for law, and course-specific tests where required.',
  'Always read the latest university admission brochure before choosing CUET subjects or filling preferences.',
];

export const universitySources = [
  {
    label: 'NIRF India Rankings 2025 - University category',
    url: 'https://www.nirfindia.org/Rankings/2025/UniversityRanking.html',
  },
  {
    label: 'UGC central/state university recognition lists',
    url: 'https://www.ugc.gov.in/',
  },
  {
    label: 'NTA CUET UG official portal',
    url: 'https://exams.nta.ac.in/CUET-UG/',
  },
];
